<script lang="ts" setup>
import { getCanonicalUrl } from '~/helpers'
import CatalogPageProvider from '~/layers/catalog/components/CatalogPageProvider.vue'

defineOptions({
  name: 'DiamondsCatalogPage',
})

const { setMetaFields } = usePageMeta()
const route = useRoute()

watch(
  () => route.path,
  () =>
    setMetaFields({
      canonical: getCanonicalUrl('/diamonds/'),
    }),
  { immediate: true },
)
</script>

<template>
  <CatalogPageProvider key="diamonds-filter" type="diamonds" />
  <!-- для корректной отрисовки роута(потом при рефакторинге удалить) -->
  <NuxtPage />
</template>
